import React from "react";
import "./dragAndDrop.scss";
import close_icon from "../../../../assets/crossIcon.svg";
import FormInputWithHeader from "../../../common/FormInputWithHeader";

const DragAndDrop = (props) => {
  const {
    fileList,
    handleDeleteFile,
    handleOnDrag,
    handleOpenFile,
    handleUpload,
    hideUploaded,
    showDropDown,
    handleDropDownChange,
  } = props;

  // Display UI ===>

  const displayDragAndDrop = () => {
    return (
      <div className="drag-and-drop-cont">
        <div
          className="drag-and-drop"
          onDragOver={(e) => {
            e.preventDefault();
          }}
          onDragEnter={(e) => {
            e.preventDefault();
          }}
          onDragLeave={(e) => {
            e.preventDefault();
          }}
          onDrop={handleOnDrag}
          onClick={handleOpenFile}
        >
          Drag and Drop your files here or Browse
        </div>
        {window.innerWidth < 767 && (
          <div className="upload-file-size-limit">Max File size : 20 MB</div>
        )}
        {fileList?.length !== 0 && !hideUploaded && (
          <div className="drag-and-drop-files">
            {fileList.map((item, ind) => (
              <div key={ind} className="drag-and-drop-files-cont">
                <div style={{ flex: "1", width: "87%" }}>
                  <div className="drag-and-drop-file-name">{item.fileName}</div>
                  <div className="drag-and-drop-file-type">{item.type}</div>
                </div>
                <img
                  src={close_icon}
                  alt=""
                  onClick={() => handleDeleteFile(ind)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            ))}
            <div
              className="drag-and-drop-files-upload"
              onClick={handleUpload}
              style={{ marginBottom: window.innerWidth > 767 ? "10px" : "" }}
            >
              Upload
            </div>
          </div>
        )}
      </div>
    );
  };

  const displayDragAndDropNew = () => {
    return (
      <div className="custom-drag-and-drop-cont">
        <div
          className="custom-drag-and-drop"
          onDragOver={(e) => {
            e.preventDefault();
          }}
          onDragEnter={(e) => {
            e.preventDefault();
          }}
          onDragLeave={(e) => {
            e.preventDefault();
          }}
          onDrop={handleOnDrag}
          onClick={handleOpenFile}
        >
          Drag and Drop your files here or Browse
        </div>
        {window.innerWidth < 767 && (
          <div className="custom-upload-file-size-limit">
            Max File size : 20 MB
          </div>
        )}
        {fileList?.length !== 0 && !hideUploaded && (
          <div className="custom-drag-and-drop-files">
            <div>
              {fileList.map((item, ind) => (
                <div className="custom-drag-and-drop-files-drop-down">
                  <div key={ind} className="custom-drag-and-drop-files-cont">
                    <div style={{ width: "87%" }}>
                      <div className="custom-drag-and-drop-file-name">
                        {item.fileName}
                      </div>
                      <div className="custom-drag-and-drop-file-type">
                        {item.type}
                      </div>
                    </div>
                    <img
                      src={close_icon}
                      alt=""
                      onClick={() => handleDeleteFile(ind)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <FormInputWithHeader
                    className="view-details-poc-input"
                    value={item?.label || ""}
                    inputType="dropdown"
                    placeholder="DiagnosticReport"
                    // disabled={item?.dropdownOptions}
                    options={item?.dropdownOptions}
                    handleOnChangeInput={(selectedValue) =>
                      handleDropDownChange(ind, selectedValue)
                    }
                  />
                </div>
              ))}
            </div>
            <div
              className="custom-drag-and-drop-files-upload"
              onClick={handleUpload}
              style={{ marginBottom: window.innerWidth > 767 ? "10px" : "" }}
            >
              Upload
            </div>
          </div>
        )}
      </div>
    );
  };

  // <===

  return <>{showDropDown ? displayDragAndDropNew() : displayDragAndDrop()}</>;
};

export default DragAndDrop;
